// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterPromoImage__root--ZcKgB"};